module.exports = __webpack_public_path__ + "static/media/id-card-back.de3aae5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Img/id-card-back.png
// module id = 868
// module chunks = 0